'use strict';

const BaseStore = require('fluxible/addons/BaseStore');

class CalloutStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._callouts = {};
        this._lastCallout = '';
    }

    open(payload = {}) {
        const {type} = payload;

        if (type) {
            this._callouts[type] = {isOpen: true};
            this._lastCallout = type;
            this.emitChange();
        }
    }

    close({type}) {
        this._callouts[type] = {isOpen: false};
        this.emitChange();
    }

    closeAll() {
        this._callouts = {};
        this.emitChange();
    }

    getCalloutData() {
        return this._callouts;
    }

    getLastCallout() {
        return this._lastCallout;
    }
};

CalloutStore.storeName = 'CalloutStore';

CalloutStore.handlers = {
    'callout:open': 'open',
    'callout:close': 'close',
    'callout:closeAll': 'closeAll'
};

module.exports = CalloutStore;



// WEBPACK FOOTER //
// ./assets/js/components/Callout/CalloutStore.es.js